// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useFlagsReadyContext } from '../contexts/LaunchDarklyContext';

/**
 * True once a flag read reflects LaunchDarkly's real value for the current
 * identity — not "the client object exists" (which can be true while still
 * evaluating the anonymous placeholder identity, mid-login) and not "the
 * catalog default" (which every flag reads until this is true).
 *
 * A route or nav decision made before this is true risks redirecting away
 * from a valid deep link before the real identity's flag value had a
 * chance to load — or, on a signed-in cold load, redirecting on the
 * anonymous identity's value because it settled first (independent
 * review, AB#29037 — this is the fix for that finding; see
 * contexts/LaunchDarklyContext.tsx for how readiness is actually tracked).
 *
 * A `REACT_APP_FLAG_*` environment value does not count as ready: LaunchDarkly
 * wins over it once it answers, so deciding on it early would be the same
 * flash. With no LaunchDarkly client ID the provider is ready at once.
 */
export function useFlagsReady(): boolean {
  return useFlagsReadyContext();
}
